import { Alert, Box, SxProps } from "@mui/material";
import { ReactNode } from "react";
import { ApiError } from "../types/ApplicationTypes";

type Props = {
    error: ApiError,
    sx?: SxProps
}



const AlertError = ({ error, sx }: Props) => {
    const getErrors = () => {
        const nodes = [] as ReactNode[];

        var keys = Object.keys(error.errors);

        keys.forEach(propName => {
            error.errors[propName].map(err => {

                nodes.push(<li>{propName}: {err}</li>)
            });
        });

        return nodes;
    }

    return (
        <Alert severity="error" sx={{ ...sx }}>
            <Box>{error.title}</Box>
            <Box>
                <ul>
                    {getErrors()}
                </ul>
            </Box>
        </Alert>
    )
}

export default AlertError;